// extracted by mini-css-extract-plugin
export var divider = "_pd-0";
export var systemMessage = "_pd-1";